import { Layout, Status } from "components"


export const PlantStatus = () => {
 return (
  <Layout>
   <Status />
  </Layout>
 )
}


